module.exports = __webpack_public_path__ + "img/baomingzhong.00f1f8ba.png";